export default __webpack_public_path__ + "static/telluride-USA-f8560b95e26016e6bb25a9e484419514.jpg";